import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '.../../environments/environment';
import { AuthService } from '../../../_services/index';
import { LoaderService } from 'app/_services/loader.service';
import { utils, write, WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { process, State } from '@progress/kendo-data-query';
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { Observable } from 'rxjs';
//import { InventoryService } from './inventory.service';
declare var $: any;

import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
import { NumberFormatStyle } from '@angular/common';
const moment = _rollupMoment || _moment;

const distinctCat = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.CATNAME === x.CATNAME) === idx);
const distinctSubCat = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.SUBCATNAME === x.SUBCATNAME) === idx);
const distinctPartType = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.PARTTYPENAME === x.PARTTYPENAME) === idx);
const distinctUOM = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.UOMTYPENAME === x.UOMTYPENAME) === idx);

@Component({
  selector: 'Vendor-Master',
  templateUrl: './vendorMaster.component.html'
})
export class VendorMasterComponent {

  
  filterData: any = {};
  public distinctCat: any[];
  public distinctSubCat: any[];
  public distinctPartType: any[];
  public distinctUOM: any[];
  search: any;
  prjId: any;
  showLoader: boolean;
  vehMaintMasterList: any;
  vehMaintUOMList: any;
  priceModal: any;
  uomModal: any;
  serviceModal: any;
  partModal: any;
  quantityModal: any;
  upQuantityModal: any;
  saveSuccess = false;
  errorInSuccess = false;
  userId: any;
  respMsg: any;
  selectedRow: number;
  maintMstDataNotFound = false;
  vehiclesCatogeryList: any;
  vehiclesTypeList: any;
  vehCotegaryId: any;
  vehTypeId: any;
  partCode: any;
  imgLoaderPath: any;
  entityCodeLoaderDiv = false;
  isVehicleUpdtbtn = false;
  newPartCode: any;
  isBtnSave = false;
  categoryList: any;
  subCategoryList: any;
  partTypeList: any;

  partNameList:any;
  vanderList:any;

  categoryId: any;
  partModalData: any;
  typeModal: any;
  categoryModal: any;
  subCategoryModal: any;
  newCategory: any;
  categoryCreateMsg: any;
  categorySuccess = false;
  categoryError = false;
  newVendor: any;

  newSubCategory:any;

  newvendorName :any;
  subCatError = false;
  subCatSuccess = false;
  newPartTypeModal: any;
  partSuccess = false;
  partError = false;
  itemToUpdate: any;
  upCategoryModal: any;
  upTypeModal: any;
  upPartModal: any;
  upUomModal: any;
  upPriceModal: any;
  upSubCategoryModal: any;
  CATNAME: string;
  partCodeModal: any;
  syncing: any;
  public roleList: any;
  loaderClass: any;
  vTypeModel: any;
  vSubCategoryModal: any;
  vCategoryModal: any;

  public groups: GroupDescriptor[] = [];
  public view: Observable<GridDataResult>;
  public gridView: DataResult;
  newQuantityModal: any;
  newPriceModal: any;
  public wrongQuantity: boolean = false;
  vendorModal: any;
  invoiceModal: any;
  inwardModal: any;
  invoiceDateModal: any;
  userName: string;
  PARTNAME: any;
  ENTRYDATE: any;
  ENTRYBY: any;
  vendorId: any;
  startDate: string;
  endDate: typeof _moment;
  vendorTypeSelect: { id: string; name: string; }[];
  public one = false ;
  public two = false ;
  isAdmin: any;
  VendorMasterId: number;
  VendorMastervalue: number;
 
  addVendorName: any;
  addVendorPhoneumber: any;
  addVendorAddress: any;
  addVendorType: any;
  addvendorError = false;
  addvendorsuccess: any;
  vendorEmail: any;
  vendorAction: string;
  venderId: any;

  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups;
    this.loadProducts();
  }

  public state: State = {
    skip: 0,
    take: 50,
    filter: {
      logic: 'and',
      filters: []
    }
  };
  vUomModel: any;
  selectedCatID: any;
  selectedSubCatID: any;
  selectedUomID: any;
  selectedTypemID: any;
  oneCatID: any;
  oneSubCatID: any;
  oneUomID: any;
  oneTypeID: any;
  newSubCategoryList: any;

  private loadProducts(): void {
    this.gridinventory = process(this.vehMaintMasterList, { group: this.groups });
  }
  public gridinventory: GridDataResult;

  constructor(
    private auth: AuthService,
    private http: HttpClient,
    private loaderService: LoaderService,
    public router: Router,
    //public _inventory: InventoryService
  ) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });
  }

	/*
   * Get All Vehicle Master List
  */

  getMaintMasterList() {
    this.loaderService.display(true);
    this.http.get(environment.apiUrl + 'maintenance/getVendorMaster?prjid=' + this.prjId).subscribe((data) => {
      this.vehMaintMasterList = data;
      console.log('all data', this.vehMaintMasterList);
      if (this.vehMaintMasterList.length > 0) {
        this.gridinventory = process(this.vehMaintMasterList, this.state);
        this.distinctCat = distinctCat(this.vehMaintMasterList);
        this.distinctSubCat = distinctSubCat(this.vehMaintMasterList);
        this.distinctPartType = distinctPartType(this.vehMaintMasterList);
        this.distinctUOM = distinctUOM(this.vehMaintMasterList);
        this.maintMstDataNotFound = false;
        this.loaderService.display(false);
      } else {
        this.maintMstDataNotFound = true;
        this.loaderService.display(false);
        this.gridinventory = process(this.vehMaintMasterList, this.state);
      }
    });
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridinventory = process(this.vehMaintMasterList, this.state);
    if (state && state.group) {
      this.gridinventory = process(this.vehMaintMasterList, this.state);
    }
  }

	/*
 *OPEN Maintenance Modal  
 */
  AddVehiclePartModal() {
    this.clearAllFields();
    $('#vehMaintMasterModal').modal('show', null);
  }

	/*
 *Open Update Inventory Modal  
 */
  UpdateVehiclePartModal(vehMaintMasterList) {
    $('#vehMaintMasterModal').modal('show', vehMaintMasterList);
  }

	/*
 *Get Vehicle Service Type 
 */
  // getVehicleServiceType(){
  //   this.http.get(environment.apiUrl+'maintenance/getVehServiceType').subscribe(data =>{
  //     this.vehMaintServiceList=data;
  //   });
  // }

	/*
 * Update Vehicle Details Opem Modal popup
 */
  // updateInventory(data) {
  //   console.log("Udtae data", data)
  //   $('#updateModal').modal('show');
  //   this.isVehicleUpdtbtn = false;
  //   this.vCategoryModal = data.CATNAME;
  //   this.vSubCategoryModal = data.SUBCATNAME;
  //   this.vTypeModel = data.PARTTYPENAME;
  //   this.partModal = data.PARTNAME;
  //   this.partCodeModal = data.PARTID;
  //   this.ENTRYDATE = data.ENTRYDATE;
  //   this.ENTRYBY = data.USERID;
  //   this.priceModal = data.UNITPRICE;
  //   this.quantityModal = data.availableQuantity;
  //   this.vUomModel = data.UOMTYPENAME

  //   this.selectedCatID = this.categoryList.filter(
  //     (item) => item.CATNAME == this.vCategoryModal
  //   );
  //   console.log("Cat ID", this.selectedCatID)
  //   this.getCatID(this.selectedCatID)


  //   this.selectedUomID = this.vehMaintUOMList.filter(
  //     (item) => item.UOMTYPENAME == this.vUomModel
  //   );
  //   console.log("UOM", this.selectedUomID)
  //   this.getUomID(this.selectedUomID)


  //   this.selectedTypemID = this.partTypeList.filter(
  //     (item) => item.PARTTYPENAME == this.vTypeModel
  //   );
  //   console.log("Type", this.selectedTypemID)
  //   this.getTypeID(this.selectedTypemID)
  // }
  
  updateActive(data){
       
      if(data.Isactive == 'Active'){
         // console.log(data.Id);
          
       this.VendorMasterId = data.Id ;
       this.VendorMastervalue = 0 ;

      }else if (data.Isactive == 'InActive'){

        this.VendorMasterId = data.Id ;
        this.VendorMastervalue = 1 ;

      }else if (data.Isactive == 'Pending'){

        this.VendorMasterId = data.Id ;
        this.VendorMastervalue = 1 ;

      }else{

       

      }

      var updateVendordata = {

        'Id': this.VendorMasterId,
        'values':this.VendorMastervalue 


      }


      console.log('295',updateVendordata);
      


      this.http.post(environment.apiUrl + 'maintenance/updateVendorMaster', updateVendordata).subscribe((data) => {
        var code: any;
        code = data;
        this.syncData();
        Swal('Quantity has been updated successfully.', 'success');
      });
    

  }







  getCatID(data) {
    for (var i = 0; i < data.length; i++) {
      this.oneCatID = data[i].ID

      this.http
        .get(environment.apiUrl + 'maintenance/getSubCategoryList?catId=' + data[i].ID)
        .subscribe((data) => {
          this.newSubCategoryList = data;
          // console.log("New sub", this.newSubCategoryList)

          this.selectedSubCatID = this.newSubCategoryList.filter(
            (item) => item.SUBCATNAME == this.vSubCategoryModal
          );
          // console.log("Type", this.selectedSubCatID)
          this.getSubCatID(this.selectedSubCatID)

        });
    }
    console.log("Cat ID..", this.oneCatID)
  }

  getSubCatID(data) {
    for (var i = 0; i < data.length; i++) {
      this.oneSubCatID = data[i].ID
    }
    console.log("Sub ppp.", this.oneSubCatID)
  }

  getUomID(data) {
    for (var i = 0; i < data.length; i++) {
      this.oneUomID = data[i].ID
    }
    console.log("Uom ID..", this.oneUomID)
  }

  getTypeID(data) {
    for (var i = 0; i < data.length; i++) {
      this.oneTypeID = data[i].ID
    }
    console.log("Type ID..", this.oneTypeID)
  }

	/*
 *Get UOM Type 
 */
  getVehicleUOMType() {
    this.http.get(environment.apiUrl + 'maintenance/getVehUOMType').subscribe((data) => {
      this.vehMaintUOMList = data;
    });
  }

  onSelectServiTypece(data) { }

  onSelectUOMType(data) { }

	/*
 *Save maintenance Master Data
 */

  saveMaintenanceMaster() {
    if (this.categoryModal == null) {
      alert('Category is Required!');
      this.isBtnSave = true;
      return;
    } else if (this.subCategoryModal == null) {
      alert('SubCategory is Required!');
      this.isBtnSave = true;
      return;
    } else if (this.typeModal == null) {
      alert('Type is Required!');
      this.isBtnSave = true;
      return;
    } else if (this.partModal == null) {
      alert('Part Name is Required!');
      this.isBtnSave = true;
      return;
    } else if (this.quantityModal == null) {
      alert('Quantity is Required!');
      this.isBtnSave = true;
      return;
    } else if (this.uomModal == null) {
      alert('UOM Type is Required!');
      this.isBtnSave = true;
      return;
    }
    else if (this.priceModal == null) {
      alert('Price is Required!')
      this.isBtnSave = true;
      return;
    }
    var data = {
      prjid: this.prjId,
      partName: this.partModal.trim(),
      quantity: this.quantityModal,
      cateId: this.categoryModal,
      subCatId: this.subCategoryModal,
      typeId: this.typeModal,
      UomTypeId: this.uomModal,
      price: this.priceModal,
      userId: this.userId,
      vendorName: this.vendorModal,
      vendorId: this.vendorId,
      invoiceNumber: this.invoiceModal,
      invoiceDate: this.invoiceDateModal,
      inwardDate: this.inwardModal,
    };
    this.isBtnSave = true;
    console.log("Part Data", data)


  

  }

  /*
 * Delete a part
 */
  deleteModalPopup(item) {
    var partID = item.PARTID;
    Swal({
      title: 'Are you sure to delete this part?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Delete it!'
    }).then((result) => {
      if (result.value) {
        this.http.get(environment.apiUrl + 'maintenance/deletePart?partId=' + partID).subscribe((data) => {
          var respStatus: any;
          respStatus = data;
          console.log('delete', data);

          if (!this.vehMaintMasterList.PARTID) {
            this.getMaintMasterList();
            Swal('Part deleted successfully.', 'success');
          } else {
            Swal('Error during part deletion.', 'error');
            this.syncData();
          }
        });
      }
    });
  }

  syncData() {
    this.syncing = true;
    this.loaderClass = 'fas fa-sync fa-spin';
    this.http.get(environment.apiUrl + 'maintenance/getMaintenanceMaster?prjid=' + this.prjId).subscribe((data) => {
      this.syncing = false;
      this.loaderClass = 'fas fa-sync';
      this.getMaintMasterList();
    });
    console.log("Refresh")
  }

	/*
  Update Part Master
*/
  onClickToUpdateInventory() {
    var data = {
      prjId: this.prjId,
      catId: this.oneCatID,
      subCatId: this.oneSubCatID,
      typeId: this.oneTypeID,
      partId: this.partCodeModal,
      uomId: this.oneUomID,
      quantity: this.newQuantityModal ? this.newQuantityModal : 0,
      unitPrice: this.newPriceModal
    }

    this.http.post(environment.apiUrl + 'maintenance/updatePartMaster', data).subscribe((data) => {
      var code: any;
      code = data;
      this.syncData();
      Swal('Quantity has been updated successfully.', 'success');
    });
    this.updateHistory('update');
  }

  updateHistory(entryType){
    var date = moment(new Date()).format('YYYY-MM-DD hh:mm:ss');
    this.newPriceModal = (this.newPriceModal == '' || this.newPriceModal == undefined || this.newPriceModal == null) ? this.priceModal : this.newPriceModal
    this.newQuantityModal = (this.newQuantityModal == '' || this.newQuantityModal == undefined || this.newQuantityModal == null) ? this.quantityModal : this.newQuantityModal
    var parObj = {
      prjid: this.prjId,
      partid: entryType == 'update' ? this.partCodeModal : this.newPartCode,
      partname: this.partModal,
      unitprice: entryType == 'update' ? this.newPriceModal : this.priceModal,
      qty: entryType == 'update' ? this.newQuantityModal : this.quantityModal,
      entryDate: entryType == 'update' ? this.ENTRYDATE : date,
      updateDate: entryType == 'update' ? date : '',
      entryBy: entryType == 'update' ? this.ENTRYBY : this.userName,
      updatedBy: entryType == 'update' ? this.userName : ''
    }

    var obj = {
      partID : parObj.partid,
      date : date,
      data : parObj
    }
   // this._inventory.addInventoryHistory(obj);
  }

  clearAllFields() {
    this.categoryModal = null;
    this.partModal = null;
    this.quantityModal = null;
    this.subCategoryModal = null;
    this.typeModal = null;
    this.uomModal = null;
    this.priceModal = null;
  }

  selectRowIndex(data, index) {
    this.selectedRow = index;
  }

  public restrictNumeric(e) {
    let input;
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
      return true;
    }
    if (e.which === 0) {
      return true;
    }
    if (e.which < 33) {
      return true;
    }
    input = String.fromCharCode(e.which);
    return !!/[\d\.\s]/.test(input);
  }

  downloadExcelFile(vehicleInfoData) {
    const ws_name = 'VehicleInfo';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(vehicleInfoData);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
    saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'VehicleInfo.xlsx');
  }
  s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  }

	/*
    * TO GET VEHICLE CATEGORY LIST
    */

  getAllVehiclesCategory() {
    this.http.get(environment.apiUrl + 'admin/getVehiclesCatogeryType').subscribe((data) => {
      this.vehiclesCatogeryList = data;
    });
  }

	/*
     *TO GET VEHICLE TYPE LIST BY CATEGORY SELECTION
    */

  onChangeVehCategory(data) {
    this.getAllVehiclesType(data.ID);
  }

	/*
     *TO GET VEHICLE TYPE LIST BY CATEGORY ID
    */

  getAllVehiclesType(catId) {
    this.http.get(environment.apiUrl + 'admin/getVehiclesType?catId=' + catId).subscribe((data) => {
      this.vehiclesTypeList = data;
    });
  }

	/*
  * Get Part Category Data
  */
  getPartCategory() {
    this.http.get(environment.apiUrl + 'maintenance/getPartCategoryList').subscribe((data) => {
      this.categoryList = data;
    });
  }
	/*
  * Get Type Details By Cat Id
  */
  onChangeCategory(data) {
    console.log('Data', data.ID);
    this.categoryId = data.ID;
    this.http
      .get(environment.apiUrl + 'maintenance/getSubCategoryList?catId=' + this.categoryId)
      .subscribe((data) => {
        this.subCategoryList = data;
      });
  }

	/*
  * Get Part Category Data
  */
  getPartTypeList() {
    this.http.get(environment.apiUrl + 'maintenance/getPartTypeList').subscribe((data) => {
      this.partTypeList = data;
    });
  }

  getPartNameList() {
    this.http.get(environment.apiUrl + 'maintenance/getPartNameList').subscribe((data) => {
      this.partNameList = data;

      console.log(597,this.partNameList );
      
    });
  }

  
  getVanderNameList() {
    this.http.get(environment.apiUrl + 'maintenance/getvanderList').subscribe((data) => {
      this.vanderList = data;

     
      
    });
  }


  createCategory() {
    $('#createCategory').modal('show');
  }

  saveCategory() {
    if (this.newCategory == null) {
      alert('Category is Required!');
      return;
    }
    var data = {
      category: this.newCategory,
      userId: this.userId
    };
    this.http.post(environment.apiUrl + 'maintenance/createCategory', data).subscribe((data) => {
      var code: any;
      code = data;
      if (code.status == 'ok') {
        this.categorySuccess = true;
        this.getMaintMasterList();
        this.getPartCategory();
        this.newCategory = null;
        setTimeout(() => {
          $('#createCategory').modal('hide');
          this.categorySuccess = false;
        }, 2000);
      } else {
        this.categoryError = true;
      }
    });
  }

  createSubCategory() {
    $('#createSubCategory').modal('show');
  }

  saveSubCategory() {
    if (this.newSubCategory == null) {
      alert('SubCategory is Required!');
      return;
    }
    var data = {
      subCategory: this.newSubCategory,
      userId: this.userId
    };
    this.http.post(environment.apiUrl + 'maintenance/createSubCategory', data).subscribe((data) => {
      var code: any;
      code = data;
      if (code.status == 'ok') {
        this.subCatSuccess = true;
        this.getMaintMasterList();
        this.newSubCategory = null;
        setTimeout(() => {
          $('#createSubCategory').modal('hide');
          this.subCatSuccess = false;
        }, 2000);
      } else {
        this.subCatError = true;
      }
    });
  }


// saveVendorMaster()
   

saveVendorMaster(){

  if (this.newvendorName == null) {
    alert('SubCategory is Required!');
    return;
  }
  var data = {
    newvendorName: this.newvendorName,
    prjId: this.prjId
  };
  this.http.post(environment.apiUrl + 'maintenance/saveNewVendor', data).subscribe((data) => {
    var code: any;
    code = data;
    if (code.status == 'ok') {
      this.subCatSuccess = true;
      this.getMaintMasterList();
      this.newSubCategory = null;
      setTimeout(() => {
        $('#newVendor').modal('hide');
        this.subCatSuccess = false;
      }, 2000);
    } else {
      this.subCatError = true;
    }
  });





}










  createNewPart() {
    $('#createPartType').modal('show');
  }

  savePartType() {
    if (this.newPartTypeModal == null) {
      alert('Part type is required!');
      return;
    }
    var data = {
      partType: this.newPartTypeModal,
      userId: this.userId
    };
    this.http.post(environment.apiUrl + 'maintenance/createPartTypeData', data).subscribe((data) => {
      var code: any;
      code = data;
      if (code.status == 'ok') {
        this.partSuccess = true;
        this.getMaintMasterList();
        this.getPartTypeList();
        
        this.newPartTypeModal = null;
        setTimeout(() => {
          $('#createPartType').modal('hide');
          this.partSuccess = false;
        }, 2000);
      } else {
        this.partError = true;
      }
    });
  }

  ngOnInit() {
    this.prjId = this.auth.getAuthentication().projectId;
    this.userId = this.auth.getAuthentication().id;

    if( this.userId == 19 ){

        this.isAdmin = true ;

    }else {
      this.isAdmin = false ;

    }

    this.userName = this.auth.getAuthentication().userName;
    this.getMaintMasterList();
    // this.getVehicleUOMType();
    // //this.getAllVehiclesCategory();
    // this.getPartCategory();
    // this.getPartTypeList();
    // this.getPartNameList();
    this.getVanderNameList();


    this.invoiceDateModal = moment().format('YYYY-MM-DD');
    this.inwardModal = moment().format('YYYY-MM-DD');



    this.vendorTypeSelect = [
      { id: 'Reparing', name: 'Reparing' },
      { id: 'Spare parts', name: 'Spare parts' },
      { id: 'Fuel', name: 'Fuel' },
      { id: 'Lubricant', name: 'Lubricant' },
      { id: 'Water bottle', name: 'Water bottle' },
      { id: 'Retreading', name: 'Retreading' },
      { id: 'Battery', name: 'Battery' }
     ];
  }





  getVanderName(event){

    this.vendorModal = event.vendorName;


    console.log('719',event.vendorName);
    

      if(event.vendorName=='New'){
        $('#newVendor').modal('show');
      }
  
     
  

      
    
           
  }

  updateStockChange(event){

             if(event.id == 1){

                this.one = true
                this.two = false 
             }else if(event.id == 2 || event.id == 3){
                  this.one = false
                  this.two = true 
                  $('#updateModal').modal('hide');

                  $('#vehMaintMasterModal').modal('show');
                 




             }

  }



  addNewVendor(){

    this.addVendorName 
    this.addVendorPhoneumber
    this.addVendorAddress
    this.addVendorType ;

    this.addvendorError
    this.addvendorsuccess
    this.cleraVendorForm()

    this.vendorAction = 'add'
    $('#addVendor').modal('show', null);

  

  }


  cleraVendorForm(){

    this.addVendorName  = '';
    this.addVendorPhoneumber = '';
    this.addVendorAddress = '';
    this.addVendorType = '';

    this.vendorEmail = '';

    this.vendorAction = '';
    this.filterData == '';

    this.addvendorError = false
  }
  

  saveNewVendordata(action){


       console.log('action',action);
       
    
    
     if((this.addVendorName == '' || this.addVendorName == undefined || this.addVendorName == null)){
       
      this.addvendorError = true

      return 
       
     }

     if((this.addVendorPhoneumber == '' || this.addVendorPhoneumber == undefined || this.addVendorPhoneumber == null)){
       
      this.addvendorError = true

      return 
       
     }
     if((this.addVendorAddress == '' || this.addVendorAddress == undefined || this.addVendorAddress == null)){
       


      
      this.addvendorError = true

      return 
       
     }
     if((this.filterData == '' || this.filterData == undefined || this.filterData == null)){
      console.log('type here');

      this.addvendorError = true

      return 
       
     }

     if((this.vendorEmail == '' || this.vendorEmail == undefined || this.vendorEmail == null)){
       
      this.addvendorError = true

      return 
       
     }



     var newVendordata = {

      'vVame': this.addVendorName,
      'vPhoneNumber':this.addVendorPhoneumber,
      'vAddress':this.addVendorAddress,
      'vType':this.filterData,
      'vendorEmail':this.vendorEmail,
      'prjId':this.prjId,
      'action':action,
      'venderId':this.venderId,
      'userId':this.userId


    }


     console.log('942',newVendordata,this.filterData);
     
    

   this.http.post(environment.apiUrl + 'maintenance/saveNewVendor', newVendordata).subscribe((data) => {
      

      this.getMaintMasterList()
      setTimeout(() => {
        $('#addVendor').modal('hide');
      }, 2000);
      Swal('New Vendor has been Added successfully.', 'success');
    });

 






  }



  updateVendorDetails(data){


    console.log('1008',data);
    

     this.vendorAction = 'update'

    
    this.addVendorName  = data['vendorName'];
    this.addVendorPhoneumber = data['vendorPhone'];
    this.addVendorAddress = data['vendorAddress'];
    this.addVendorType = data['vendorType'];
    this.vendorEmail = data['vendorEmail'];

    this.venderId = data['Id']
    
    console.log( this.addVendorName  );

    $('#addVendor').modal('show', null);
    


  }







}



// WEBPACK FOOTER //
// ./src/app/maintenance/part/vendorMaster/vendorMaster.component.ts